import { useEffect } from 'react';

export const useScrollReset = (dependencies = []) => {
  useEffect(() => {
    const forceScrollToTop = () => {
      console.log('🔴 FORCING SCROLL RESET', { 
        currentScroll: window.pageYOffset,
        docScroll: document.documentElement.scrollTop,
        bodyScroll: document.body.scrollTop
      });
      
      // Disable any smooth scrolling temporarily
      const originalBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      
      // Nuclear option - multiple scroll reset approaches
      window.scrollTo(0, 0);
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Override any position values
      document.documentElement.style.scrollTop = '0px';
      document.body.style.scrollTop = '0px';
      
      // Find and reset ALL scrollable containers aggressively
      const scrollableSelectors = [
        'main',
        'div[class*="overflow"]',
        '.overflow-y-auto',
        '.overflow-auto',
        '.overflow-scroll',
        '[class*="flex-1"]',
        '.h-screen',
        '.min-h-screen'
      ];
      
      scrollableSelectors.forEach(selector => {
        try {
          const elements = document.querySelectorAll(selector);
          elements.forEach(el => {
            if (el.scrollTop !== 0) {
              console.log('🔴 Resetting scroll on:', el.className, 'scrollTop:', el.scrollTop);
              el.scrollTop = 0;
              el.style.scrollTop = '0px';
            }
          });
        } catch (e) {
          console.warn('Selector error:', selector, e);
        }
      });
      
      // Force page position
      if (window.pageYOffset !== 0) {
        console.log('🔴 Window still scrolled, forcing again');
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
      
      // Restore original scroll behavior
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalBehavior;
        document.body.style.scrollBehavior = '';
      }, 200);
    };
    
    // Immediate reset
    forceScrollToTop();
    
    // More aggressive progressive resets
    const timeouts = [0, 1, 5, 10, 25, 50, 100, 200, 300, 500].map(delay => 
      setTimeout(forceScrollToTop, delay)
    );
    
    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, dependencies);
};

export default useScrollReset; 